import { render, staticRenderFns } from "./AddRepresentativeForm.vue?vue&type=template&id=fae759b8&scoped=true"
import script from "./AddRepresentativeForm.vue?vue&type=script&lang=ts"
export * from "./AddRepresentativeForm.vue?vue&type=script&lang=ts"
import style0 from "./AddRepresentativeForm.vue?vue&type=style&index=0&id=fae759b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae759b8",
  null
  
)

export default component.exports